module.exports = __webpack_public_path__ + "img/6.2b0b0757.png";